import * as Sentry from '@sentry/browser';
import React from 'react';
import Header from '../component/header/header';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        Sentry.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <div>
                <Header />
                <h1 className='mt-5'>Something went wrong.</h1>
                <button className='btn btn-sm primary_fill_sm_button' onClick={() => {
                    window.location.reload();
                }}>Reload page</button>
            </div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary